<template lang="pug">
  .authorizations(v-if="show")
    EditableBlock(
      :text="tr.menu.btn"
      :field="'menu.btn'"
      section="header"
    )
      //:href="'https://swi.tips/?locale='+lang_switips_link+'#register'"
      vButton(
        :href="urlToPartner()"
        target="_blank"
        class='authorizations__btn'
        :white="dark"
        :small="small"
        :large="large" )
    EditableBlock(
      :text="tr.menu.login"
      :field="'menu.login'"
      section="header"
    )
      vLogin(
        :white="dark"
      )
</template>

<script>
import vButton from '../../components/elements/vButton'
import vLogin from '../../components/elements/vLogin'
import EditableBlock from '../../components/widgets/EditableBlock'
import langOps from '@/mixins/langOps'
import partnerUrl from '@/mixins/getPartnerUrl'
export default {
  data () {
    return {
      section: 'header'
    }
  },
  mixins: [langOps, partnerUrl],
  components: {
    vButton,
    vLogin,
    EditableBlock
  },
  props: {
    id: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}

</script>
<style lang="scss">
  .authorizations {
    display: flex;
    align-items: center;
    font-size: 20px;

    &__btn {
      margin-right: 35px;
      background-color: #fff;
      @media(max-width: 1366px){
        margin-right: 10px;
        white-space: nowrap;
      }
      @media (max-width: 480px) {
        display: inline-block;
        margin-right: 0;
        margin-bottom: 40px;
        padding: 20px 65px;
      }

    }

    @media (max-width: 480px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
</style>
